import React from 'react';
import { IntlProvider } from 'react-intl';
import { flattenMessages } from '../_i18n/utils';
import messages from '../_i18n/messages';

function IntlProviderConfigured({ locale, children }) {

    return (
        <IntlProvider locale={locale} messages={flattenMessages(messages[locale])}>
            {children}
        </IntlProvider>
    )
}

export default IntlProviderConfigured;